import {
  Button,
  TextField,
  Card,
  Box,
  Divider,
  Typography,
  Grid,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
} from '@mui/material'
import LoadingButton from '@mui/lab/LoadingButton'
import React, { useState, useEffect } from 'react'
import Proposal from '../../../Proposal'
import Contract from '../../../Contract'
import bigInt from 'big-integer'
import { ToastContainer, toast } from 'react-toastify'

export default function CreateProposall() {
  const [updateValue, setupdateValue] = useState(0)
  const [variableName, setVariableName] = React.useState('')
  const [showLoader, setShowLoader] = useState(false)
  const [proposalDetails, setProposalDetails] = useState('')
  const [currentValueOfselectedVar, setcurrentValueOfselectedVar] = useState('')
  const variableNames = ['minimumStakeAmount', 'maxValidators']

  const handleChange = async (event) => {
    // console.log("eevevvve", event.target.value);

    const {
      target: { value },
    } = event
    if (event.target.value) {
      // let value = await Proposal.currentValue(event.target.value);
      if (event.target.value === 'maxValidators') {
        let MaxVal = await Contract.maxValidators()
        console.log('this is maxValidators : ', MaxVal)
        setcurrentValueOfselectedVar(MaxVal.toString())
      }
      if (event.target.value === 'minimumStakeAmount') {
        let minAmount = await Contract.minimumStakeAmount()
        let convrtTostring = minAmount.toString()
        let remove18 = convrtTostring.slice(0, -18)
        setcurrentValueOfselectedVar(remove18)
      }
    }
    setVariableName(
      value,
      // On autofill we get a stringified value.
      // typeof value === 'string' ? value.split(',') : value,
    )
  }
  const createProposal = async () => {
    // console.log("check name", variableName);
    setShowLoader(true)
    try {
      let ethe = bigInt(1 * 10 ** 18)
      console.log('create proposal', updateValue)
      let proposalCreate = await Proposal.createProposal(
        proposalDetails,
        variableName,
        updateValue,
        { value: ethe.value },
      )
      // console.log(proposalCreate, "proposalCreate");
      let wait = await proposalCreate.wait()
      if (wait) {
        setShowLoader(false)
        toast('Proposal created successfully.')
      }
    } catch (error) {
      setShowLoader(false)

      if (error.code === 4001) {
        toast.error(error.message)
      }
      if (error.error.data.message) {
        toast.error(error.error.data.message)
      }

      console.log(error)
    }
  }
  return (
    <>
      <ToastContainer />
      <div
        className="stack_modal"
        style={{
          display: 'flex',
          justifyContent: 'center',
          padding: '8px',
          marginTop: '24px',
        }}
      >
        <Card item className="section-card">
          <Typography className="header-text">Create Proposal</Typography>

          <Grid container>
            {/* <Grid
              item
              xs={12}
              ml={3}
              mr={3}
              sx={{ display: 'flex', justifyContent: 'space-between' }}
            >
              <label
                htmlFor="validatorAddress"
                style={{ paddingTop: '1rem', fontSize: '1rem' }}
              >
                Validator Address
              </label>
              <TextField
                label="Enter your address"
                variant="filled"
                sx={{ my: 1 }}
              />
            </Grid> */}
            <Grid
              item
              xs={12}
              sx={{
                display: ['block', 'flex'],
                justifyContent: 'space-between',
                alignItems: 'center',
                mx: 2,
                mt: 1,
              }}
            >
              <Grid item xs={12} sx={{ display: 'flex' }}>
                <Typography>Variable name</Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sx={{ display: 'flex', justifyContent: 'center' }}
              >
                <FormControl
                  sx={{ minWidth: 222 }}
                  variant="filled"
                  fullWidth
                  hiddenLabel
                >
                  {/* <InputLabel>Select name</InputLabel> */}
                  <Select
                    value={variableName}
                    onChange={handleChange}
                    inputProps={{ 'aria-label': 'Without label' }}
                    variant="filled"
                    size="small"
                    displayEmpty
                  >
                    <MenuItem value="">Select</MenuItem>
                    {variableNames.map((e) => {
                      return <MenuItem value={e}>{e}</MenuItem>
                    })}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                display: ['block', 'flex'],
                justifyContent: 'space-between',
                alignItems: 'center',
                mx: 2,
                mt: 1,
              }}
            >
              <Grid item xs={12} sx={{ display: 'flex' }}>
                <Typography>Set Value</Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sx={{ display: 'flex', justifyContent: 'center' }}
              >
                <TextField
                  fullWidth
                  hiddenLabel
                  // label="Staker Amount"
                  variant="filled"
                  value={updateValue}
                  onChange={(e) => setupdateValue(e.target.value)}
                  size="small"
                />
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                display: ['block', 'flex'],
                justifyContent: 'space-between',
                alignItems: 'center',
                mx: 2,
                mt: 1,
              }}
            >
              <Grid item xs={12} sx={{ display: 'flex' }}>
                <Typography>Amount of selected variable</Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sx={{ display: 'flex', justifyContent: 'center' }}
              >
                <TextField
                  fullWidth
                  hiddenLabel
                  size="small"
                  variant="filled"
                  // label="Enter details"
                  value={
                    currentValueOfselectedVar
                      ? currentValueOfselectedVar
                      : 'null'
                  }
                  onChange={(e) => setProposalDetails(e.target.value)}
                />
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                display: ['block', 'flex'],
                justifyContent: 'space-between',
                alignItems: 'center',
                mx: 2,
                mt: 1,
              }}
            >
              <Grid item xs={12} sx={{ display: 'flex' }}>
                <Typography>Details</Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sx={{ display: 'flex', justifyContent: 'center' }}
              >
                <TextField
                  fullWidth
                  hiddenLabel
                  size="small"
                  variant="filled"
                  // label="Enter details"
                  value={proposalDetails}
                  onChange={(e) => setProposalDetails(e.target.value)}
                />
              </Grid>
            </Grid>
          </Grid>
          <div
            style={{
              marginTop: '1rem',
              justifyContent: 'center',
              textAlign: 'center',
            }}
          >
            {showLoader === true ? (
              <LoadingButton
                sx={{
                  mt: 1,
                }}
                color="primary"
                loading
                variant="contained"
                size="large"
              >
                Submit
              </LoadingButton>
            ) : (
              <Button
                variant="contained"
                sx={{ mt: 1 }}
                onClick={() => createProposal()}
                size="large"
              >
                Create Proposal
              </Button>
            )}
          </div>
        </Card>
      </div>
    </>
  )
}
